<template>
  <div class="py-2" v-if="task.body">
    <div
      v-for="section in task.body.sections"
      :key="section.name"
    >
      <h3 v-if="section.title" class="mb-2">
        {{ section.title }}
      </h3>

      <p v-if="section.description" class="mt-0">
        {{ section.description }}
      </p>

      <div v-for="form in section.forms" :key="form.name">
        <ExternalDynamicForm
          :form="form"
          :type="task.taskType.type"
          :organization="organization"
        />
      </div>
    </div>

    <div>
      <span>* Campos obrigatórios</span>
    </div>

    <div class="inline-block w-full mt-3">
      <button
        type="button"
        class="justify-center float-right w-full px-4 py-2 text-base font-medium text-white border border-transparent rounded bg-orange-organization md:w-1/5 hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-organization"
        :disabled="sending || disabled"
        @click="finishTask()"
      >
        <div>Enviar</div>
      </button>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/event-bus'
import ExternalDynamicForm from './commons/ExternalDynamicForm'

export default {
  name: 'ExternalTaskBody',
  components: {
    ExternalDynamicForm
  },
  props: {
    task: {
      type: Object,
      required: true
    },
    sending: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    availableStatus: {
      type: Array,
      required: true
    },
    ticket: {
      type: String,
      required: true
    },
    ticketTask: {
      type: String,
      required: true
    },
    organization: {
      type: String,
      required: true
    }
  },

  beforeDestroy () {
    EventBus.$off('saveForm')
  },

  methods: {
    finishTask () {
      EventBus.$emit('saveForm', true)
    }
  }
}
</script>
